export function isWeChat() {
	var ua = navigator.userAgent.toLowerCase()
	return ua.indexOf('micromessenger') !== -1
}
